import { Button } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const StopAudioButton = styled(Button)`
  ${({ $show, theme: { color, spacing } }) => css`
    position: absolute;
    height: 36px;
    opacity: 0;
    left: -99999px;
    ${$show &&
    css`
      left: initial;
      opacity: 1;
      transition: opacity 0.4s;
    `}
  `}
`;
